import { FC } from "react"

interface NavigationCardProps {
    icon: React.FC<React.SVGProps<SVGSVGElement>>
    title: string
    subtitle: string
    onClick: () => void
}

export const NavigationCard: FC<NavigationCardProps> = ({ icon: Icon, title, subtitle, onClick }) => {
    return (
        <div
            className="box flex items-center justify-between cursor-pointer hover:bg-gray-50 transition"
            onClick={onClick}
        >
            <div className="flex items-center gap-3">
                <Icon width={24} height={24} />
                <div>
                    <div className="font-semibold">{title}</div>
                    <div className="text-sm text-gray-500">{subtitle}</div>
                </div>
            </div>
            <span className="text-gray-400">→</span>
        </div>
    )
}
